import React from "react";
import {
  MenuItem as SpectrumMenuItem,
  type MenuItemProps,
} from "@react-spectrum/s2";

const Spectrum = SpectrumMenuItem as React.FC<MenuItemProps>;

/** S2 types `MenuItem` as returning `ReactNode` (TS2786 under @types/react 18). */
export function MenuItem(props: MenuItemProps) {
  return <Spectrum {...props} />;
}

export type { MenuItemProps };
